import { render, staticRenderFns } from "./TrustUs.vue?vue&type=template&id=4d89978f&scoped=true&"
import script from "./TrustUs.vue?vue&type=script&lang=js&"
export * from "./TrustUs.vue?vue&type=script&lang=js&"
import style0 from "./TrustUs.vue?vue&type=style&index=0&id=4d89978f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89978f",
  null
  
)

export default component.exports